module.exports = __webpack_public_path__ + "static/img/JHF.930f1da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/JHF.jpg
// module id = Rlh7
// module chunks = 0